<template>
  <div class="header">
    <div class="pull-left">
      <div class="logo">
        <a>
          <span>Kellner Admin</span>
        </a>
      </div>
      <div class="hamburger sidebsar-toggle">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
    </div>

    <div class="pull-right p-r-15">
      <div class="logo">
        <a>
          <span>Restaurant Name</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
